module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_21.7a4b7929.jpg";